import React from "react";

const GlobalLoader = () => {
  return (
    <div className="flex flex-col justify-center items-center min-h-[calc(100vh-64px)] w-full bg-surface relative overflow-hidden">
      {/* Immersive Background Grid (same as admin pages) */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#8080800a_1px,transparent_1px),linear-gradient(to_bottom,#8080800a_1px,transparent_1px)] bg-[size:32px_32px] pointer-events-none [mask-image:radial-gradient(ellipse_80%_80%_at_50%_0%,#000_70%,transparent_100%)]" />

      {/* Center Spinner Container */}
      <div className="relative flex flex-col justify-center items-center z-10 p-8 rounded-3xl bg-white/5 dark:bg-black/10 border border-vlight/20 dark:border-white/5 backdrop-blur-sm shadow-2xl">
        <div className="relative flex justify-center items-center w-24 h-24 mb-6">
          {/* Dual Ring Gradient Spinner */}
          <div className="absolute inset-0 border-4 border-transparent border-t-orange-500 border-l-rose-500 rounded-full animate-spin [animation-duration:1.5s]" />
          <div className="absolute inset-2 border-4 border-transparent border-b-purple-500 border-r-indigo-500 rounded-full animate-spin [animation-duration:1s] [animation-direction:reverse]" />

          {/* Pulsing Core */}
          <div className="w-6 h-6 bg-gradient-to-br from-orange-400 to-rose-500 rounded-full animate-pulse shadow-[0_0_15px_rgba(249,115,22,0.5)]" />
        </div>

        {/* Loading Text */}
        <div className="flex flex-col items-center">
          <h3 className="text-sm font-bold text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-rose-500 uppercase tracking-[0.4em] mb-2 animate-pulse">
            ParamBhog
          </h3>
          <p className="text-xs text-vheavy/50 dark:text-white/40 tracking-wider font-medium animate-pulse">
            Loading your workspace...
          </p>
        </div>
      </div>
    </div>
  );
};

export default GlobalLoader;
